import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6afb2908"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "datastore-info-drawer",
  class: "card card-drawer background-fb datastore-drawer"
}
const _hoisted_2 = { class: "card-header header-label d-flex flex-row justify-content-between align-items-center" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = { class: "card-body d-flex flex-column overflow-auto font-size-14" }
const _hoisted_5 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color-red" }, "*", -1))
const _hoisted_7 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_8 = { class: "margin-top-20 d-flex flex-column" }
const _hoisted_9 = { class: "d-flex justify-content-between margin-top-10" }
const _hoisted_10 = { class: "datastore-quota-bar margin-top-10" }
const _hoisted_11 = {
  key: 0,
  class: "datastore-hint margin-top-10"
}
const _hoisted_12 = { class: "margin-top-20 d-flex flex-column" }
const _hoisted_13 = { class: "d-flex align-items-center gap-1" }
const _hoisted_14 = { class: "margin-top-10" }
const _hoisted_15 = {
  key: 0,
  class: "margin-top-20 d-flex flex-column"
}
const _hoisted_16 = {
  key: 0,
  class: "datastore-share-summary margin-top-10"
}
const _hoisted_17 = {
  key: 0,
  class: "datastore-hint"
}
const _hoisted_18 = {
  key: 1,
  class: "datastore-hint margin-top-10"
}
const _hoisted_19 = {
  key: 0,
  class: "footer card-footer d-flex justify-content-end align-items-center"
}

import { computed, ref, watch } from "vue";
import { ElButton, ElDivider, ElInput, ElTag, ElTooltip } from "element-plus";
import { TYPE } from "vue-toastification";
import { showAlert } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { DataStoreTable } from "@/datastore/types";
import {
  canDataStore,
  updateTable,
} from "@/datastore/services/datastore.service";

const SUMMARY_LIMIT = 3;


export default /*#__PURE__*/_defineComponent({
  __name: 'TableInfoDrawer',
  props: {
    table: {},
    rowLimit: {}
  },
  emits: ["close", "changed"],
  setup(__props: any, { emit: __emit }) {

const { t } = i18n.global;

/** Enough to recognize who a table is shared with; the rest is a count. */
const props = __props;
const emit = __emit;

const name = ref(props.table.name);
const description = ref(props.table.description);

watch(
  () => props.table,
  (table) => {
    name.value = table.name;
    description.value = table.description;
  }
);

const usagePercent = computed(() =>
  props.rowLimit > 0 ? (props.table.rowCount / props.rowLimit) * 100 : 0
);

/** Validity is a computed over the model refs, as everywhere else in the app. */
const isValid = computed(() => name.value.trim().length > 0);
const isDirty = computed(
  () =>
    name.value.trim() !== props.table.name ||
    description.value.trim() !== props.table.description
);
const canSave = computed(() => isValid.value && isDirty.value);

function formatCount(n: number): string {
  return n.toLocaleString("en-US");
}

async function onSaveDetails() {
  const newName = name.value.trim();
  if (!newName) {
    showAlert(TYPE.WARNING, t("DataStore.NameRequired"));
    return;
  }
  try {
    await updateTable(props.table.id, {
      name: newName,
      description: description.value.trim(),
    });
    showAlert(TYPE.SUCCESS, t("DataStore.DetailsSaved"));
    emit("changed");
  } catch (e: any) {
    showAlert(TYPE.ERROR, e.message ?? t("Common.UnknownError"));
  }
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, _toDisplayString(_unref(t)("DataStore.TableDetails")), 1),
      _createElementVNode("button", {
        id: "datastore-info-drawer-close",
        type: "button",
        class: "btn btn-link",
        "aria-label": _unref(t)('Common.Close'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
      }, [
        _createVNode(_component_font_awesome_icon, { icon: "times" })
      ], 8, _hoisted_3)
    ]),
    _createVNode(_unref(ElDivider), { style: {"margin":"0"} }),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("label", null, [
          _createElementVNode("strong", null, [
            _createTextVNode(_toDisplayString(_unref(t)("Common.Name")), 1),
            _hoisted_6
          ])
        ]),
        _createVNode(_unref(ElInput), {
          id: "datastore-info-name",
          modelValue: name.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((name).value = $event)),
          size: "small",
          disabled: !_unref(canDataStore)('TABLE.EDIT')
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("label", null, [
          _createElementVNode("strong", null, _toDisplayString(_unref(t)("DataStore.Description")), 1)
        ]),
        _createVNode(_unref(ElInput), {
          id: "datastore-info-description",
          modelValue: description.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((description).value = $event)),
          size: "small",
          disabled: !_unref(canDataStore)('TABLE.EDIT')
        }, null, 8, ["modelValue", "disabled"])
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("label", null, [
          _createElementVNode("strong", null, _toDisplayString(_unref(t)("DataStore.Usage")), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(formatCount(_ctx.table.rowCount)) + " / " + _toDisplayString(formatCount(_ctx.rowLimit)) + " " + _toDisplayString(_unref(t)("DataStore.Rows").toLowerCase()), 1),
          _createElementVNode("span", null, _toDisplayString(usagePercent.value.toFixed(1)) + "%", 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("i", {
            class: _normalizeClass({ warn: usagePercent.value > 80 }),
            style: _normalizeStyle({ width: Math.min(100, usagePercent.value) + '%' })
          }, null, 6)
        ]),
        (usagePercent.value > 80)
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
              _createVNode(_component_font_awesome_icon, {
                icon: "info-circle",
                class: "color-warning margin-right-10"
              }),
              _createTextVNode(" " + _toDisplayString(_unref(t)("DataStore.QuotaWarning")), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("label", _hoisted_13, [
          _createElementVNode("strong", null, _toDisplayString(_unref(t)("DataStore.OwnerOrganization")), 1),
          _createVNode(_unref(ElTooltip), {
            effect: "custom",
            placement: "top",
            content: _unref(t)('DataStore.IsolationHint')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_font_awesome_icon, {
                icon: "info-circle",
                class: "datastore-info-icon"
              })
            ]),
            _: 1
          }, 8, ["content"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(ElTag), {
            size: "small",
            class: "datastore-primary-tag"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.table.organizationName || _unref(t)("DataStore.DefaultOrganization")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      (_unref(canDataStore)('SHARE') && _ctx.table.owned)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _createElementVNode("label", null, [
              _createElementVNode("strong", null, _toDisplayString(_unref(t)("DataStore.SharedWithOrganizations")), 1)
            ]),
            (_ctx.table.sharedWith.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.table.sharedWith.slice(0, SUMMARY_LIMIT), (share) => {
                    return (_openBlock(), _createBlock(_unref(ElTag), {
                      key: share.organizationId,
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(share.name), 1)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (_ctx.table.sharedWith.length > SUMMARY_LIMIT)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_17, "+" + _toDisplayString(_ctx.table.sharedWith.length - SUMMARY_LIMIT), 1))
                    : _createCommentVNode("", true)
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_unref(t)("DataStore.NotShared")), 1))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_unref(canDataStore)('TABLE.EDIT'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createVNode(_unref(ElButton), {
            id: "datastore-info-save",
            class: "btn-oneTeg2",
            size: "small",
            disabled: !canSave.value,
            onClick: onSaveDetails
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)("DataStore.SaveDetails")), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})